import {getNextSibling, getClosest} from '../dom/findElement';

function showInvalidField (id, message) {

	let field = document.getElementById(id);
	if (!field) return;
	let info;

	const type = field.getAttribute('type');
	field.classList.remove("is-valid");
	field.classList.add("is-invalid");

	if (type=='radio' || type=='checkbox') {
		// Bootstrap 5 markup: input + label live inside div.form-check, and the
		// .helper feedback is a sibling of that wrapper (BS4 used custom-radio).
		let label = getNextSibling(field, "label");
		if (label) label.style.color = "#3f4040";
		let wrapper = getClosest(field, "div.form-check");
		info = getNextSibling(wrapper || field, '.helper');
		if (info) info.style.display = "block";
	} else {
		info = getNextSibling(field, 'div.helper');
	}
	if (info) {
		info.textContent = '';
		info.textContent = message;
		info.classList.remove('valid-feedback');
		info.classList.add('invalid-feedback');
	}
	
}

export default showInvalidField;